import { render, staticRenderFns } from "./EventModalCatalog.vue?vue&type=template&id=11002e05&scoped=true"
import script from "./EventModalCatalog.vue?vue&type=script&lang=js"
export * from "./EventModalCatalog.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalog.vue?vue&type=style&index=0&id=11002e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11002e05",
  null
  
)

export default component.exports